import script from "./SelectionArea.vue?vue&type=script&lang=js"
export * from "./SelectionArea.vue?vue&type=script&lang=js"

import "./SelectionArea.vue?vue&type=style&index=0&id=6c4fb262&lang=css"

export default script